export const formatFecha = (fecha)=>{
    return `${fecha.split('/')[1]}/${fecha.split('/')[0]}/${fecha.split('/')[2]}`
}

export const formatoNumero = (number) => {
    return new Intl.NumberFormat("es-CL").format(number);
};


export const withoutDots = (actual) => {
    return ("" + actual).replace(/\./g, "");
};

export const withoutDotsNumber = (actual) => {
    return parseFloat(actual.toString().replace(/\./g, "").replace(",", "."));
};
  